var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraveler2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 1204,
    viewBox: "0 0 706 1204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.05 319.33C424.63 305.68 405.78 434.28 419.81 492.09C421.18 495.13 407.9 605.33 465.49 710.66C502.32 771.67 582.82 702.46 579.81 643.34C578.25 582.1 587.42 501.98 591.08 477.2C597.21 435.65 567.25 320.22 493.06 319.33H493.05Z",
    fill: "#594D26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.4 710.41C484.95 783.45 509.57 841.64 520.55 871.69C555.13 887.11 630.08 853.39 623.27 833.68C619.66 812.36 590.21 735.71 583.8 668.31C568.56 617.54 504.39 601.86 479.3 610.19C468.5 616.41 430.94 622.91 462.4 710.42V710.41Z",
    fill: "#726235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.75 948.95C680.57 964.33 705.62 1001.27 688.54 1016.63C667.78 1035.31 649.9 1032.32 621.29 1025.35C589.74 1017.66 586.27 988.74 575.84 966.73C564.61 943.03 584.9 924.17 611.94 926.49C626.56 927.74 640.75 931.72 655.21 935.25C665.16 937.67 668.05 948.63 675.75 948.95Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.94 859.17C572.39 851.46 601.62 831.95 613.62 846.91C626.64 869.46 647.85 892.57 649.95 896.13C653.58 902.29 672.92 942.65 675.75 948.95C685.6 970.82 579.98 973.6 578.34 972.39C571.46 964.08 568.31 947.2 559.64 922.17C551.31 898.11 548.87 879.59 565.94 859.17Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.82 861.65C645.68 869.71 670.78 890.99 679.38 900.25C690.44 912.16 697.78 922.45 705.08 935.84C705.01 945.67 682.24 948.01 664.45 925.17C645.31 903.43 597.03 904.97 602.01 877.06C604.3 864.17 606.22 849.94 627.82 861.66V861.65Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.65 798.6C585.65 798.6 525.66 812.83 510.17 843.95C494.67 875.06 524.39 913.36 550.55 888.83C576.71 864.29 608.08 852.36 622.89 854.4C637.69 856.44 649.48 778.34 585.66 798.6H585.65Z",
    fill: "#E8E1CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.88 660.53L481.31 321.46C481.31 321.46 507.09 345.08 519.23 356.72C531.37 368.36 566.44 481.64 567.79 527.2C569.14 572.75 565.88 660.53 565.88 660.53Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.81 550.87C292.81 594.99 263.98 666.41 217.85 638.25C184.01 617.6 146.89 529.6 162.21 492.04C168.85 475.75 186.23 441.57 204.29 436.11C276.5 414.34 292.81 491.9 292.81 550.86V550.87Z",
    fill: "#DB9669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.9 337.21C212.27 356.01 165.16 395.9 146.95 415.25C123.93 441.35 95.95 496.32 96.27 504.43C87.08 578.53 110.57 638.69 152.76 722.81C157.09 731.43 154.75 741.32 155.53 749.43C158.62 790.28 56.9 941.14 64.49 1144.76C139.09 1264.32 579.8 1174.51 668.03 1115.54C672.09 1015.86 641.62 960.32 567.94 683.9C565.4 674.36 565.07 670.35 565.88 660.53C579.12 499.94 533.27 392.02 495.74 346C471.21 315.92 298.04 379.29 261.89 337.21H261.9Z",
    fill: "#594D26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.25 421.86C151.24 369.97 94.39 462.81 69.98 507.77C60.02 526.11 9.99999 607.62 1.05999 710.48C-1.64001 771.71 100.99 738.99 127 695.22C162.02 658.76 211.99 604.01 226.42 588.01C250.6 561.18 277.08 465.99 219.25 421.86Z",
    fill: "#726235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469 42.8304C508.42 87.3304 507.16 155.94 507.16 177.44C507.16 201.73 521.68 369.94 430.44 340.02C403.45 331.17 379.12 246.8 375.98 217.44C371.43 174.9 416.71 136.06 439.83 103.42C448.02 91.8604 434.62 45.9004 446.86 40.4604C454.95 36.8604 465.63 39.0404 469 42.8304Z",
    fill: "#CBC1AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.32 321.46C480.9 320.64 496.98 326.59 496.98 338.73C496.98 357.12 457.52 424.82 440.87 400.71C430.58 385.8 409.65 345.9 423.46 328.57C435.7 313.19 464.62 305.18 481.32 321.46Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.01 217.1L271.97 219.61C271.63 218.77 271.31 217.92 271.01 217.1Z",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.59 43.9105C422.1 24.6405 378.26 -5.00951 327.39 0.720488C313.94 2.24049 288.49 15.5105 266.01 32.7605C211.09 74.8905 174.85 236.46 224.66 327.24C242.72 338.26 265.54 341.2 294.03 352.18C357.68 376.7 326.09 328.271 338.69 287.94C352.93 242.41 359.59 180.58 389.48 136.87C410.3 106.42 420.31 98.9905 463.49 80.2205C487.52 69.7805 477.2 49.9205 460.59 43.9105Z",
    fill: "#594D26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.81 416.68C423.38 412.94 437.96 409.19 452.54 405.45C493.16 622.96 495.67 835.72 508.42 1049.76C491.01 1055.96 473.59 1062.15 456.18 1068.35C450.91 854.29 445.39 640.15 408.81 416.68Z",
    fill: "#726235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.88 906.89C213.35 973.2 211.45 1046.62 207.34 1112.97C221.76 1139.53 372.28 1128.03 419.79 1098.33C421.25 1028.03 410.8 947.57 393.55 884.17C336.51 886.79 266.92 904.27 209.89 906.89H209.88Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.33 728.74C207.33 728.74 448.36 733.43 565.88 660.52L567.94 683.89C567.94 683.89 491.94 744.169 155.52 749.419L153.87 730.53L207.32 728.729L207.33 728.74Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.66 908.15C227.91 969.22 231.19 1033.17 227.07 1099.52C247.06 1126.64 361.65 1115.72 413.2 1093.48C414.66 1023.18 404.03 963.7 386.77 900.29C329.73 902.91 272.69 905.52 215.66 908.14V908.15Z",
    fill: "#594D26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.54 807.28C82.52 867.58 120.02 905.74 145.09 929.65C168.53 931.21 245.29 877.75 231.92 861.73C220.99 843.07 158.96 752.73 129.07 691.98C115.78 680.83 36.72 670.48 16.22 687.17C8.33001 696.81 -24.9 736.61 35.54 807.28Z",
    fill: "#726235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.09 851.68C561.1 913.71 566.57 975.22 567.5 1039.57C589.66 1050.08 610.34 1035.36 631.61 1017.84C627.91 950.54 623.19 885.62 602.51 830.49C549.44 850.08 606.16 832.09 553.09 851.68Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.59 851.141C574.42 905.551 582.09 965.39 583.02 1029.74C596.04 1041.37 619.3 1028.02 631.65 1017.79C627.95 950.49 629.13 887.86 608.46 832.73C555.38 852.32 611.66 831.551 558.59 851.141Z",
    fill: "#594D26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.68 957.69C313.01 971.49 346.1 1001.44 333.14 1020.42C317.4 1043.48 299.31 1044.82 269.87 1044.82C237.4 1044.82 227.17 1017.54 211.83 998.63C195.31 978.27 210.56 955.13 237.37 950.98C251.87 948.73 266.6 949.24 281.49 949.24C291.73 949.24 297.13 959.2 304.69 957.69H304.68Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.45 884.23C256.71 887.84 286.14 902.56 296.68 909.51C310.25 918.46 316.51 929.03 330.08 938C332.25 951.5 314.26 954.25 291.56 936.28C271.81 929.56 208.93 932.12 216.01 905.31C223.78 890.9 213.68 877.97 237.44 884.23H237.45Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.73 896.48C181.17 887.47 204.94 861.59 220.16 873.27C238.14 892.1 264.23 909.53 267.11 912.49C272.1 917.62 300.44 952.25 304.68 957.7C310.57 965.25 303.5 976.5 289.17 979.3C283.45 985.05 273.4 990.41 265.09 987.44C258.93 992.36 254.58 996.26 241.64 994.96C236.77 997.74 231.83 1005.14 226.31 1002.85C207.76 1000.11 199.89 981.45 185.53 959.18C171.73 937.78 164.98 920.36 176.73 896.49V896.48Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.53 919.03C160.17 925.42 164.82 931.23 171.78 935.88C188.12 913.6 208.21 894.44 233.78 879.82C228.59 873.71 223.4 867.61 218.22 861.51C188.81 862.87 166.36 883.59 155.53 919.03Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73 230.8C284.73 230.8 292.57 263.95 290.25 277.99C287.93 292.03 287.7 331.05 287.7 331.05L422.09 340.01L326.97 220.7L284.72 230.8H284.73Z",
    fill: "#FFC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.73 106.98L473.68 229.5L443.94 316.58L327.56 287L300.31 233.33L289.63 123.75L466.73 106.98Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.72 151.63L313.65 239.26L371.2 282.42H450.87L473.69 229.51C473.69 229.51 479.1 292.85 480.03 311.41C480.96 329.97 464.26 349.45 430.85 353.16C397.45 356.87 373.52 355.02 356.72 338.31C339.92 321.61 305.59 290.06 305.59 290.06L292.73 151.63H292.72Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79 279.04C385.79 279.04 403.27 299.5 415.47 297.73C427.67 295.96 446.6 275.5 446.6 275.5L418.89 263.88L385.79 279.03V279.04Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.06 222.51C428.06 222.51 416.9 148.37 408.7 144.94C400.5 141.52 397.08 221.66 397.08 221.66C397.08 221.66 376.19 227.48 376.4 241.39C376.62 255.3 389.69 256.6 399.55 257.28C409.41 257.96 427.88 257.04 438.17 257.28C446.61 257.48 466.14 230.13 428.06 222.51Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23 277.27C392.23 277.27 403.05 285.46 413.56 284.32C424.07 283.18 435.9 269.99 435.9 269.99L406.56 265.2L392.23 277.26V277.27Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.87 247.13C409.87 247.13 400.89 238.19 392.82 243.04C387.78 246.07 385.78 250.04 385.78 250.04L409.86 247.13H409.87Z",
    fill: "#56445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27 248.82C421.27 248.82 429.29 238.93 437.79 242.96C441.78 244.85 444.99 248.82 444.99 248.82H421.27Z",
    fill: "#56445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.63 249.5C446.63 249.5 459.07 265.67 483.56 274.06C483.56 274.06 454.32 293.54 439.16 281.99C424 270.44 424 275.5 416.77 273.33C409.54 271.16 405.24 251.79 416.77 247.33C434.47 240.48 446.63 249.5 446.63 249.5Z",
    fill: "#3D1E07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72 249.5C384.72 249.5 362.14 272.02 337.86 279.59C337.86 279.59 377.04 293.54 392.2 281.99C407.36 270.44 407.36 275.5 414.59 273.33C421.81 271.16 426.12 251.79 414.59 247.33C396.89 240.48 384.73 249.5 384.73 249.5H384.72Z",
    fill: "#3D1E07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57 290.06C305.57 290.06 264.71 214.23 264.71 176.94C264.71 139.65 289.63 123.74 289.63 123.74L293.81 156.2L312.82 285.7L305.57 290.06Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4 187.15C278.4 187.15 259.67 182.44 264.71 217.64C269.75 252.84 300.01 247.28 300.01 247.28L284.57 187.15H278.39H278.4Z",
    fill: "#FFC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.23 195.96C282.23 195.96 268.98 192.63 272.55 217.53C276.12 242.43 297.52 238.5 297.52 238.5L286.6 195.96H282.23Z",
    fill: "#FC7272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.33 204.81C381.592 204.81 389.1 197.301 389.1 188.04C389.1 178.778 381.592 171.27 372.33 171.27C363.068 171.27 355.56 178.778 355.56 188.04C355.56 197.301 363.068 204.81 372.33 204.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.79 201.18C385.346 201.18 390.66 195.866 390.66 189.31C390.66 182.755 385.346 177.44 378.79 177.44C372.234 177.44 366.92 182.755 366.92 189.31C366.92 195.866 372.234 201.18 378.79 201.18Z",
    fill: "#3B496D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77 193.84L356.04 192.04C356.04 192.04 358.33 205.18 372.32 205.69C386.31 206.2 389.76 193.84 389.76 193.84H389.77Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9 188.46C388.739 188.46 389.42 187.779 389.42 186.94C389.42 186.1 388.739 185.42 387.9 185.42C387.061 185.42 386.38 186.1 386.38 186.94C386.38 187.779 387.061 188.46 387.9 188.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35 157.95L390.17 163.54L356.28 165.42L354.3 155.37L390.35 157.95Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.21 206.79C456.472 206.79 463.98 199.282 463.98 190.02C463.98 180.758 456.472 173.25 447.21 173.25C437.948 173.25 430.44 180.758 430.44 190.02C430.44 199.282 437.948 206.79 447.21 206.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.68 203.16C460.236 203.16 465.55 197.846 465.55 191.29C465.55 184.734 460.236 179.42 453.68 179.42C447.124 179.42 441.81 184.734 441.81 191.29C441.81 197.846 447.124 203.16 453.68 203.16Z",
    fill: "#3B496D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.65 195.82L430.92 194.02C430.92 194.02 433.21 207.16 447.2 207.67C460.64 208.16 464.64 195.82 464.64 195.82H464.65Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.79 190.44C463.63 190.44 464.31 189.76 464.31 188.92C464.31 188.081 463.63 187.4 462.79 187.4C461.951 187.4 461.27 188.081 461.27 188.92C461.27 189.76 461.951 190.44 462.79 190.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.57 157.82L468.38 163.41L434.49 165.23L432.53 155.18L468.57 157.82Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.23 293.71C344.32 318.31 392.76 318.17 405.48 355.04C408.32 363.28 427.94 410.34 405.75 403.3C380.41 395.26 282.86 362.93 280.43 326.63C279.48 312.42 285.34 301.34 293.98 293.71C298.25 289.92 301.72 288.87 307.52 288.87C311.42 288.87 318.1 293.09 316.23 293.71Z",
    fill: "#42350F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.2 234.38C364.024 234.38 374.42 228.255 374.42 220.7C374.42 213.144 364.024 207.02 351.2 207.02C338.376 207.02 327.98 213.144 327.98 220.7C327.98 228.255 338.376 234.38 351.2 234.38Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.04 204.67C456.22 204.67 445.82 210.8 445.82 218.35C445.82 225.9 456.22 232.03 469.04 232.03C470.74 232.03 472.39 231.92 473.98 231.72L472.33 204.8C471.25 204.71 470.15 204.66 469.04 204.66V204.67Z",
    fill: "#F99595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.85 193.42C431.85 193.42 434.01 193.57 436.65 194.02C439.29 194.47 439.5 193.44 443.46 193.82C447.42 194.2 446.42 194.51 448.84 194.13C451.26 193.75 453.01 194.64 454.44 194.74C455.87 194.84 456.98 193.84 459.27 194.74C461.56 195.64 464.66 195.81 464.66 195.81C464.66 195.81 456.31 196.22 453.01 195.81C449.71 195.4 448.53 195.18 445.83 195.4C443.13 195.62 441.37 194.32 439.4 194.86C437.43 195.4 436.19 196.5 433.44 195.51C431.08 194.66 429.77 193.57 431.85 193.41V193.42Z",
    fill: "#3BD3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08 191.44C357.08 191.44 359.24 191.59 361.88 192.04C364.52 192.49 364.73 191.46 368.69 191.84C372.65 192.22 371.65 192.53 374.07 192.15C376.49 191.77 378.24 192.66 379.67 192.76C381.1 192.86 382.21 191.86 384.5 192.76C386.79 193.66 389.89 193.83 389.89 193.83C389.89 193.83 381.54 194.24 378.24 193.83C374.94 193.42 373.76 193.2 371.06 193.42C368.36 193.64 366.6 192.34 364.63 192.88C362.66 193.42 361.42 194.52 358.67 193.53C356.31 192.68 355 191.59 357.08 191.43V191.44Z",
    fill: "#3BD3DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.57 33.2998C299.31 57.5398 263.25 125.69 239.78 205.2C230.6 236.31 210.55 335.23 258.37 361.91C310.69 391.1 313.9 336.24 321.1 267.95C325.11 229.86 351.35 186.71 376.78 161.45C407.81 130.63 448.21 138.62 468.45 115.69C503.42 76.0499 476.25 25.0998 431.57 33.2798V33.2998Z",
    fill: "#E8E1CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.33 839.17C176.33 839.17 124 871.77 119.22 906.19C114.44 940.61 154.8 967.46 171.78 935.87C188.76 904.28 214.71 882.98 229.39 880.2C244.07 877.42 230.37 799.64 176.33 839.16V839.17Z",
    fill: "#E8E1CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 705.09,
    height: 1203.69,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraveler2);
export default __webpack_public_path__ + "static/media/traveler2.svg";
export { ForwardRef as ReactComponent };